// let cache = new Map();

// function cachingGet(get){

//     return function cachedGet(url){
//         const key = url;

//         if (cache.has(key)){
//             return cache.get(key)
//         }else{
//             const request = get(...arguments);
//             cache.set(key, request);
//             return request;
//         }
//     }
// }

import axiosHandler from '@/app/axios-handler'

const baseDomain= process.env.VUE_APP_API_URL;
const baseURL = `${baseDomain}`;

const instance = axiosHandler.axios.create({
    baseURL
    // In case that you need a token:
    //headers: { "Authorization": "Bearer yourToken" }
});

instance.interceptors.request.use(config => {
    // 下面会说在什么时候存储 token
    if (localStorage.token) {
        config.headers.Authorization = 'Bearer ' + localStorage.token
    }
    return config
},error =>{
    alert("错误的传参", 'fail');
    return Promise.reject(error);
});

// instance.get = cachingGet(instance.get);

// instance.clearCache = function(){
//     cache = new Map();
// };

export default instance
